var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "btn_type_list" }, [
    _c(
      "button",
      {
        staticClass: "btn_item btn_prev",
        attrs: { type: "button" },
        on: { click: _vm.goToPrevPage },
      },
      [_c("span", { staticClass: "ico_cafenew" }, [_vm._v("이전 보기")])]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn_item btn_next",
        attrs: { type: "button" },
        on: { click: _vm.goToNextPage },
      },
      [_c("span", { staticClass: "ico_cafenew" }, [_vm._v("다음 보기")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }